export var statusFilterItemV1 = {
    all: 'all',
    scheduled: 'scheduled',
    recurring_scheduled: 'recurring_scheduled',
    draft: 'draft',
    completed: 'completed',
};
export var statusFilterItem = {
    scheduled: 'scheduled',
    recurring_scheduled: 'recurring_scheduled',
    draft: 'draft',
    completed: 'completed',
};
export var TYPE_FILTER_KEY = 'engagement.typeFilter';
export var STATUS_FILTER_KEY = 'engagement.statusFilter';
export var SORT_ORDER_KEY = 'engagement.sortOrder';
export var CREATOR_FILTER_KEY = 'engagement.creatorFilter';
